import React from 'react';
import Profile from "./Profile/index";

const UserDetails = () => (
  <Profile />
);

export default UserDetails;
